import React from 'react'

function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center py-4 fixed bottom-0 w-full">
      &copy; 2024 Admin Dashboard. All rights reserved.
    </footer>
  );
}

export default Footer